import { render, staticRenderFns } from "./VideoTile.vue?vue&type=template&id=11bcda7e"
import script from "./VideoTile.vue?vue&type=script&lang=js"
export * from "./VideoTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports